<template>
  <v-app id="app">
    <NavigationDrawer :items="navDrawerItems" />
    <AppBar :items="navItems" />

    <v-main>
      <v-container class="container">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-col :cols="isXs ? 12 : 10" v-if="!$route.meta.hideCart === true">
              <v-scale-transition>
              <Cart/>
              </v-scale-transition>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" class="">
              <router-view></router-view>
            </v-col>
          </v-row>
      </v-container>
    </v-main>
    <Footer :footerLinks="footerLinks" />
  </v-app>
</template>

<script>
  import Footer from '@/components/Footer.vue'
  import Cart from '@/components/shop/Cart.vue'
  import AppBar from '@/components/AppBar.vue'
  import NavigationDrawer from '@/components/NavigationDrawer.vue'
  import { useDisplay } from 'vuetify'
  import { useSeoMeta } from '@unhead/vue';


  export default {
    components: { Cart, Footer, AppBar, NavigationDrawer },
    props: {
      source: String,
    },
    setup() {
      useSeoMeta({
        title: 'Markus Nentwich',
        description: 'Musiker, Komponist, Arrangeur, Dirigent und Pädagoge aus Leopoldsdorf im Marchfeld, wohnhaft in Wien.',
      });
      const { xs } = useDisplay()
      return {
        isXs: xs
      }
    },
    data: () => ({
      navItems: [
        {
          label: 'Home',
          path: '/',
          icon: 'mdi-home'
        },
        {
          label: 'Notenshop',
          path: '/shop',
          icon: 'mdi-playlist-music-outline'
        },
        {
          label: 'Biografie',
          path: '/biography',
          icon: 'mdi-card-account-details'
        },
        {
          label: 'Kontakt',
          path: '/contact',
          icon: 'mdi-email'
        }
      ],
      footerLinks: [
        {
          label: 'Impressum',
          path: '/contact',
          icon: 'mdi-playlist-music-outline'
        },
        {
          label: 'AGB',
          path: '/terms',
          icon: 'mdi-email'
        }
      ]
    }),
    computed: {
      navDrawerItems: function() {
        return this.navItems.concat(this.footerLinks)
      }
    },
  }
</script>

<style>
.app-bar-gradient {
  background: linear-gradient(90deg, #ECE6DD 40%, #2E5346 30%);
}
.v-toolbar__content, .v-toolbar__extension {
	padding: 0px !important;
}
.container {
  max-width: 1300px;
}
.box-shadow {
  box-shadow: 5px 5px 0px #d5d5d5 !important;
  height: 100%;
}
.primary--text {
  color: #2E5346 !important;
}
</style>

